import GeometryEditor from './GeometryEditor/EditorDialog'
import ExampleTool from './ExampleTool';
import RouteEditor from './RouteEditor/RouteEditorDialog';
import ExportKmlTool from './ExportKml/ExportKmlTool';
import OptimizedRoutingTool from './RouteOptomization/Optimizedroutingtool';
import CopierTool from './Copier/CopierTool';
import LayerBuilderTool from './LayerBuilder/LayerBuilderTool';

const plugins = [
  // {
  //   toolname: "ExampleTool",
  //   toolversion: "0.1.0",
  //   description: "ExampleTool",
  //   tool_component: ExampleTool
  // },
  {
    toolname: "Editor",
    toolversion: "0.1.0",
    description: "Create and edit map features including points, lines, and polygons with interactive editing tools.",
    tool_component: GeometryEditor
  },
  {
    toolname: "Route Editor",
    toolversion: "0.1.0",
    description: "Build routes by placing waypoints. Drag to reroute via OSRM.",
    tool_component: RouteEditor
  },
  {
    toolname: "Export KML",
    toolversion: "0.1.0",
    description: "Export a layer as a KML file.",
    tool_component: ExportKmlTool
  },
  {
    toolname: "Optimized Routing",
    toolversion: "0.1.0",
    description:
      "Compute an optimized route across a set of point stops, with an optional depot origin and optional existing broadband linestring reference. Outputs a routed LineString layer.",
    tool_component: OptimizedRoutingTool,
  },
  {
    toolname: "Copier",
    toolversion: "0.1.0",
    description:
      "Copy features from a source layer into a destination layer with field-level mapping. Supports append and overwrite modes. Field mapping respects schema data types — compatible fields are auto-matched by name, incompatible types are disabled in the selector.",
    tool_component: CopierTool,
  },
    {
    toolname: "Layer Builder",
    toolversion: "0.1.0",
    description:
      "Creates new feature layer from Templete layer or via manual layer configuration.",
    tool_component: LayerBuilderTool,
  }

  // {
  //   toolname: "Ring Importer",
  //   toolversion: "0.1.0",
  //   description: "Imports pre-planned route to system netive format",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Layer Exporter",
  //   toolversion: "0.1.0",
  //   description: "Exports layer to desired geospatial formats",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Muti Ring Generator",
  //   toolversion: "0.1.0",
  //   description: "plans Muti Ring throuth waypoints",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Conflict Resolver",
  //   toolversion: "0.1.0",
  //   description: "Manual layer conflict resolver tool",
  //   tool_component: ExampleTool
  // },
];

export default plugins;